export default __webpack_public_path__ + "static/media/Inter-UI-Thin-BETA.6ca93976.woff2";